import React from 'react';
import ReactDOM from 'react-dom/client';

import Router from './routes/Router';

const container = document.getElementById('app');
const root = ReactDOM.createRoot(container);

root.render(<Router />);
